// Core
import React from "react"
import styled from "styled-components"

import colors from "../../styles/colors"

function backgroundColor(props) {
  const {
    grayEbonyBG,
    zirconBG,
    lightGreenBG,
    yellowMoonBG,
    orangeChocolateBG,
    redRubyBG,
    blueMayaBG,
    pictonBlueBG,
    greenDullLimeBG,
  } = props

  if (grayEbonyBG) return colors["gray-ebony"]
  if (zirconBG) return colors["zircon"]
  if (lightGreenBG) return colors["light-green"]
  if (yellowMoonBG) return colors["yellow-moon"]
  if (orangeChocolateBG) return colors["orange-chocolate"]
  if (redRubyBG) return colors["red-ruby"]
  if (blueMayaBG) return colors["blue-maya-blue"]
  if (pictonBlueBG) return colors["picton-blue"]
  if (greenDullLimeBG) return colors["green-dull-lime"]

  return colors["light-green"]
}

function textColor(props) {
  const { lightText, dark } = props

  if (dark) return colors["gray-ebony"]
  if (lightText) return "#ffffff"

  return colors["gray-ebony"]
}

export const Link = styled.a`
  display: inline-block;
  font-size: 1.7rem;
  font-weight: 700;
  padding: 20px 15px;
  text-decoration: none;
  border-radius: 5px;
  transition: all 150ms linear 0s;
  width: 100%;
  max-width: 338px;
  min-height: 6rem;
  text-align: center;
  /* text-transform: uppercase; */
  margin-top: 40px;
  cursor: pointer;

  text-decoration: ${({ underline }) => (underline ? "underline" : "none")};

  color: ${props => textColor(props)};
  background-color: ${props => backgroundColor(props)};

  &:hover {
    opacity: 0.8;
  }
`

export default function CTALink(props) {
  return <Link {...props}>{props.children}</Link>
}
